import { Component } from '@angular/core';
import { AuditReportComponent as LibAuditReportComponent } from '@nucleus/audit-report-ui';

/**
 * Thin shell hosting `<lib-audit-report>` from `@nucleus/audit-report-ui`.
 * The actual page logic lives in the lib; this component exists so the
 * route in reports-routing.module.ts keeps its existing reference.
 *
 * DI tokens (NUCLEUS_AUDIT_SERVICE, NUCLEUS_AUDIT_PERMISSIONS,
 * NUCLEUS_AUDIT_REPORT_FILENAME) are registered at the ReportsModule
 * level via `NUCLEUS_AUDIT_UI_PROVIDERS` so sibling tenant components
 * see the same adapter graph.
 */
@Component({
  selector: 'app-audit-report',
  standalone: false,
  template: '<lib-audit-report></lib-audit-report>',
  styles: [':host { display: flex; flex-direction: column; height: 100%; }'],
})
export class AuditReportComponent {}
